import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import axiosPost from '../../helpers/axios-helper';
import PasswordInput from '../../components/PasswordInput';
import './styles/Login.css';

export default function Login() {
    const navigate = useNavigate();
    const [cookies, setCookie] = useCookies(['auth_token']);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        if (!email || !password) {
            setError('Please enter both email and password.');
            setIsLoading(false);
            return;
        }

        axiosPost(
            'auth/login',
            { 'Content-Type': 'application/json' },
            { email, password },
            (resp) => {
                setIsLoading(false);
                if (resp?.success && resp?.data?.token) {
                    // Store token in cookie (expires in 30 days)
                    setCookie('auth_token', resp.data.token, { 
                        path: '/', 
                        maxAge: 30 * 24 * 60 * 60,
                        sameSite: 'lax'
                    });
                    // Store account info in localStorage (non-sensitive data)
                    localStorage.setItem('auth_account', JSON.stringify(resp.data.account));
                    // Redirect to dashboard
                    navigate('/dashboard');
                } else {
                    setError(resp?.response || 'Login failed. Please try again.');
                }
            },
            (err) => {
                setIsLoading(false);
                console.error('Login error:', err);
                setError('An error occurred. Please try again.');
            }
        );
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <div className="login-header">
                    <h1 className="login-title">Dashboard Login</h1>
                    <p className="login-subtitle">Enter your credentials to access the dashboard</p>
                </div>

                <form onSubmit={handleSubmit} className="login-form">
                    {error && (
                        <div className="login-error">
                            {error}
                        </div>
                    )}

                    <div className="login-field">
                        <label htmlFor="email" className="login-label">Email</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="login-input"
                            placeholder="Enter your email"
                            autoComplete="email"
                            disabled={isLoading}
                        />
                    </div>

                    <div className="login-field">
                        <label htmlFor="password" className="login-label">Password</label>
                        <PasswordInput
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="login-input"
                            placeholder="Enter your password"
                            autoComplete="current-password"
                            disabled={isLoading}
                        />
                    </div>

                    <button 
                        type="submit" 
                        className="login-button"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>
            </div>
        </div>
    );
}
